// Google Ads (gtag). The loader + Consent Mode defaults live in public/index.html; the script loads only after "Accept all".
const LABELS = { signup: process.env.REACT_APP_GOOGLE_ADS_SIGNUP_LABEL, purchase: process.env.REACT_APP_GOOGLE_ADS_PURCHASE_LABEL };
const gtag = (...a) => window.gtag?.(...a);
const ready = () => !!window.__amAdsOn && !!window.__amAdsOk?.();
let last = null;

export const adsPageView = (pathname) => {
  window.__amAdsLoad?.();
  if (!ready() || pathname === last) return;
  last = pathname;
  const page_location = window.__amAdsUrl();
  gtag("set", { page_location });
  gtag("event", "page_view", { page_location, page_path: new URL(page_location).pathname, page_title: document.title });
};

// Fires only with consent granted, the tag loaded and a label configured (REACT_APP_GOOGLE_ADS_<NAME>_LABEL); otherwise a no-op.
export const trackConversion = (name, params = {}) => {
  const label = LABELS[name];
  if (!label || !ready()) return false;
  gtag("event", "conversion", { send_to: label.includes("/") ? label : `${window.__amAdsId}/${label}`, ...params });
  return true;
};

// Accepting on the current page counts that page once.
if (typeof window !== "undefined") window.addEventListener("am:consent", () => adsPageView(window.location.pathname));
